export const SELL_CAR_SEO_INFO_SECTIONS = [
    {
        heading: "Documents required to sell used cars online?",
        buttonText: "Get car price",
        isTipsToSellUsedCars: false,
        gaEvent: "getCarPriceInPageCTA",
        gaViewEvent: "documentsRequiredView",
        styleName: "styles.sellUsedCarBg"
    },
    {
        heading: "Tips to sell used cars",
        buttonText: "Sell car now",
        isTipsToSellUsedCars: true,
        gaEvent: "sellCarNowInPageCTA",
        gaViewEvent: "tipsToSellView",
        styleName: "styles.withoutBg"
    }
];
